import { Alert } from '@mui/material';
import type { AlertProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { resolveInlineError } from '@/api/REST/errors';

interface ApiErrorAlertProps {
  error: unknown;
  severity?: AlertProps['severity'];
}

export const ApiErrorAlert = ({
  error,
  severity = 'error',
}: ApiErrorAlertProps) => {
  const { t, i18n } = useTranslation('errors');
  const message = resolveInlineError(error, { t, i18n, namespace: 'errors' });

  if (!message) return null;

  return <Alert severity={severity}>{message}</Alert>;
};
